import { getAlpha2Codes } from "i18n-iso-countries";
import CurrencyList from "currency-list";

export const Countries = Object.keys(getAlpha2Codes()).map((key) => key);
export const countryEnumToNumber: Record<string, number> = Countries.reduce(
  (curr, country, index) => ({ ...curr, [country]: index }),
  {},
);
export const countryNumToEnum = Object.entries(countryEnumToNumber).reduce(
  (acc, [key, value]) => ({ ...acc, [value]: key }),
  {},
) as Record<string, string>;

export const Languages = ["PT", "EN", "DE", "ES", "FR", "IT"] as const;

export enum PaymentModel {
  Unit = 0,
  Fixed = 1,
  Hourly = 2,
  PerKm = 3,
}

export const BriefingLanguages = ["PT", "EN", "DE"] as const;

export enum ReservationRegion {
  Faro = "Faro",
  Lisbon = "Lisbon",
  Porto = "Porto",
  Madeira = "Madeira",
  Azores = "Azores",
  Marrocos = "Marrocos",
}

export const reservationRegionEnumToNumber: Record<ReservationRegion, number> =
  {
    Faro: 0,
    Lisbon: 1,
    Porto: 2,
    Madeira: 3,
    Azores: 4,
    Marrocos: 5,
  };

export const numToReservationRegionEnum = Object.entries(
  reservationRegionEnumToNumber,
).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {}) as Record<
  number,
  ReservationRegion
>;

export const reservationRegionAsArray = Object.values(ReservationRegion);

export const Currencies = Object.keys(CurrencyList.getAll("en_US"));
